import { StyleColumn } from '@components/styles'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import PageBreadCrum from '../components/pageBreadCrumb'
import { fetchByKey } from '../fetch'
import AdminDefaultEditorForm from '../form'
import AdminDefaultSeoForm from '../seoForm'
const title = 'Refund Policy'
const editorPageKey = 'refundPolicy'
const seoPageKey = 'refundPolicySeo'
const AdminRefundPolicy = () => {
  const { data: editor } = useSelector((state: any) => state.refundPolicy)
  const { data: seo } = useSelector((state: any) => state.refundPolicySeo)
  useEffect(() => {
    if (!editor?.id) {
      fetchByKey(editorPageKey)
    }
    if (!seo?.id) {
      fetchByKey(seoPageKey)
    }
  }, [])

  return (
    <StyleColumn>
      <PageBreadCrum
        title={title}
        onClick={() => {
          window.open('/#/refund-policy', '_blank', 'noopener,noreferrer')
        }}
      />
      <AdminDefaultEditorForm
        pageKey={editorPageKey}
        title={title}
        data={editor}
      />
      <AdminDefaultSeoForm
        data={seo}
        pageKey={seoPageKey}
        title={`${title} Seo`}
      />
    </StyleColumn>
  )
}
export default AdminRefundPolicy
